export const webhooks = { HOOKS: 'v2/hooks', HOOKS_DETAILS: 'v2/hooks/{id}' };
